import axios from "axios"
import { HEADERS, HEADER_FORM_DATA } from "../../../../API/UrlAndPaths"
import store from "../../../../Redux/store";
import { store_printers_list } from "./deviceSettingsSlice";
import { setBillLoading, setErrorSnack, setSnackMsg, setSuccessSnack } from "../../Sales/Billing/Slice/billingScreenSlice";
import { setSubmitLoading } from "../../../../Redux/Dashboard/mainDashBoardSlice";
import { isQzTrayAvailable, printHtml, printPdf } from "./qzTrayService";


export const getAllPrinterDevicesAPICall=async()=>{
    store.dispatch(setSubmitLoading(true))
    try {
        const response = await axios.get('http://localhost:5000/printers',HEADERS);
        store.dispatch(store_printers_list(response?.data))
        store.dispatch(setSubmitLoading(false))
        } catch (error) {
          store.dispatch(setSubmitLoading(false))
          store.dispatch(store_printers_list([]))
          store.dispatch(setSnackMsg("Cannot Find Printers"))
          store.dispatch(setErrorSnack(true))
      }
}
export const printRequestAPICall=async(body,manualPrint)=>{
    try {
        const response = await axios.post('http://localhost:5000/thermalPrint',body,HEADER_FORM_DATA);
        store.dispatch(setBillLoading(false))
        } catch (error) {
            // store.dispatch(setSnackMsg("Print request failed"))
            store.dispatch(setErrorSnack(true))
            store.dispatch(setBillLoading(false))
            manualPrint()
      }
}
export const kotPrintRequestAPICall=async(body,manualPrint)=>{
    try {
        const response = await axios.post('http://localhost:5000/kotThermalPrint',body,HEADERS);
        store.dispatch(setBillLoading(false))
        } catch (error) {
            // store.dispatch(setSnackMsg("Print request failed"))
            store.dispatch(setErrorSnack(true))
            store.dispatch(setBillLoading(false))
            manualPrint()
      }
}

/**
 * QZ Tray Print - Silent printing using QZ Tray
 * @param {string} printerName - Name of the printer
 * @param {string} htmlContent - HTML content to print
 * @param {object} options - Print options (width, margins, etc.)
 * @param {function} fallbackPrint - Fallback function if QZ Tray fails
 */
export const qzTrayPrintAPICall = async (printerName, htmlContent, options = {}, fallbackPrint) => {
    store.dispatch(setBillLoading(true));
    try {
        const available = await isQzTrayAvailable();
        if (!available) {
            throw new Error('QZ Tray not connected');
        }
        
        await printHtml(printerName, htmlContent, options);
        store.dispatch(setBillLoading(false));
        store.dispatch(setSnackMsg("Print sent successfully"));
        store.dispatch(setSuccessSnack(true));
        return true;
    } catch (error) {
        console.error('QZ Tray print failed:', error);
        store.dispatch(setSnackMsg("QZ Tray print failed, using fallback"));
        store.dispatch(setErrorSnack(true));
        store.dispatch(setBillLoading(false));
        if (fallbackPrint) {
            fallbackPrint();
        }
        return false;
    }
};

/**
 * QZ Tray PDF Print - Silent PDF printing using QZ Tray
 * @param {string} printerName - Name of the printer
 * @param {Blob|string} pdfData - PDF blob or base64 string
 * @param {object} options - Print options
 * @param {function} fallbackPrint - Fallback function if QZ Tray fails
 */
/**
 * Generate KOT HTML from data
 * @param {object} kotData - KOT data object
 * @param {number} paperWidth - Paper width in mm (48 or 72)
 */
const generateKotHtml = (kotData, paperWidth = 48) => {
    const decimalPosition = localStorage.getItem("decimalPosition") || 0;
    const orderData = kotData.orderInfo || [];
    
    // Calculate totals
    let totalItem = orderData.length;
    let totalQty = orderData.reduce((sum, item) => sum + Number(item?.qty || 0), 0);
    
    // Font sizes based on paper width - larger for better clarity
    const baseFontSize = paperWidth === 72 ? '16px' : '14px';
    const itemFontSize = paperWidth === 72 ? '15px' : '13px';
    const headerFontSize = paperWidth === 72 ? '18px' : '16px';
    const tokenFontSize = paperWidth === 72 ? '56px' : '48px';
    const tokenLabelSize = paperWidth === 72 ? '22px' : '18px';
    
    const orderItems = orderData.map((res, i) => {
        const comboItems = (res?.productList || []).map(combo => 
            `<li style="font-size: ${itemFontSize}; margin-left: 8px; font-weight: 600;">${combo?.qty} X ${combo?.productName}</li>`
        ).join('');
        
        return `
            <tr style="border-bottom: 1px dashed #000;">
                <td style="padding: 6px 4px; text-align: left; vertical-align: top; font-size: ${itemFontSize};">
                    <div style="display: flex; flex-direction: column; gap: 2px;">
                        <span style="font-weight: 700; font-size: ${itemFontSize};">${res?.productName || '-'}</span>
                        ${res?.nativeName ? `<span style="font-weight: 700; font-size: ${itemFontSize};">${res.nativeName}</span>` : ''}
                        ${res?.customerNote ? `<span style="font-weight: 600; font-size: 12px; font-style: italic;">Note: ${res.customerNote}</span>` : ''}
                    </div>
                </td>
                <td style="padding: 6px 4px; text-align: right; vertical-align: top; font-size: ${itemFontSize}; font-weight: 700;">
                    ${Number(res?.qty || 0).toFixed(Number(decimalPosition))}
                </td>
            </tr>
            ${comboItems ? `<tr><td colspan="2" style="padding: 2px 4px;"><ul style="margin: 0; padding-left: 20px; list-style-type: disc;">${comboItems}</ul></td></tr>` : ''}
        `;
    }).join('');

    return `
        <div style="font-family: 'Arial', 'Helvetica', sans-serif; width: ${paperWidth}mm; padding: 3mm; background: #fff; color: #000; -webkit-font-smoothing: antialiased;">
            <!-- Bill Details -->
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 4px; margin-bottom: 8px; font-size: ${baseFontSize};">
                <div style="font-weight: 700;">BILL NO: ${kotData.ordName || '---'}</div>
                <div style="text-align: right; font-weight: 700;">${kotData.ordType || '---'}</div>
                <div style="font-size: ${itemFontSize};">${kotData.orderDate?.split(' ')[0] || '---'} ${kotData.orderDate?.split(' ')[1] || '---'}</div>
                <div></div>
                <div style="font-size: ${itemFontSize};">WAITER: <span style="font-weight: 600;">${kotData.waiterName || '---'}</span></div>
                ${kotData.tables ? `<div style="text-align: right; font-size: ${itemFontSize};">TABLE: <span style="font-weight: 600;">${kotData.tables}</span></div>` : '<div></div>'}
            </div>
            
            <!-- Items Table -->
            <table style="width: 100%; border-collapse: collapse; border-top: 2px solid #000; border-bottom: 2px solid #000;">
                <thead>
                    <tr style="border-bottom: 2px solid #000; background: #f0f0f0;">
                        <th style="padding: 6px 4px; text-align: left; font-size: ${headerFontSize}; font-weight: 700;">Item</th>
                        <th style="padding: 6px 4px; text-align: right; font-size: ${headerFontSize}; font-weight: 700;">Qty</th>
                    </tr>
                </thead>
                <tbody>
                    ${orderItems}
                    <tr style="border-top: 2px solid #000; background: #f0f0f0;">
                        <td style="padding: 6px 4px; font-size: ${baseFontSize}; font-weight: 700;">Total Items: ${totalItem}</td>
                        <td style="padding: 6px 4px; text-align: right; font-size: ${baseFontSize}; font-weight: 700;">Qty: ${totalQty}</td>
                    </tr>
                </tbody>
            </table>
            
            <!-- Token -->
            <div style="text-align: center; margin-top: 10px; padding: 8px; border: 2px dashed #000;">
                <div style="font-size: ${tokenLabelSize}; font-weight: 700; letter-spacing: 1px;">YOUR TOKEN NO</div>
                <div style="font-size: ${tokenFontSize}; line-height: 1.1; font-weight: 900; margin-top: 4px;">${kotData.transNo || '---'}</div>
            </div>
        </div>
    `;
};

/**
 * QZ Tray KOT Print - Silent KOT printing using QZ Tray (generates PDF from KOT data)
 * @param {string} printerName - Name of the printer
 * @param {object} kotData - KOT data object with orderInfo, ordName, etc.
 * @param {object} options - Print options (width, etc.)
 * @param {function} fallbackPrint - Fallback function if QZ Tray fails
 */
export const qzTrayKotPrintAPICall = async (printerName, kotData, options = {}, fallbackPrint) => {
    try {
        console.log('📋 KOT Print Request:', {
            printerName,
            orderInfoCount: kotData?.orderInfo?.length || 0,
            orderInfo: kotData?.orderInfo,
            ordName: kotData?.ordName,
            transNo: kotData?.transNo
        });
        
        const available = await isQzTrayAvailable();
        if (!available) {
            throw new Error('QZ Tray not connected');
        }
        
        // Import html2pdf dynamically
        const html2pdf = (await import('html2pdf.js')).default;
        
        const paperWidth = options.width || 48; // Default 48mm for KOT
        
        // Generate KOT HTML from data
        const kotHtml = generateKotHtml(kotData, paperWidth);
        
        // Create a temporary container
        const tempContainer = document.createElement('div');
        tempContainer.innerHTML = kotHtml;
        tempContainer.style.position = 'absolute';
        tempContainer.style.left = '-9999px';
        tempContainer.style.top = '0';
        tempContainer.style.width = `${paperWidth}mm`;
        document.body.appendChild(tempContainer);
        
        // Calculate height based on content
        const contentElement = tempContainer.firstElementChild;
        if (!contentElement) {
            console.error('KOT HTML content element not found');
            document.body.removeChild(tempContainer);
            throw new Error('Failed to generate KOT content');
        }
        
        // Wait for content to render
        await new Promise(resolve => setTimeout(resolve, 100));
        
        const ppi = 96;
        const pixelsToMM = (px) => px * (25.4 / ppi);
        const contentHeightMM = pixelsToMM(contentElement.offsetHeight) * 1.2;
        
        console.log('📋 KOT Content:', { height: contentHeightMM, width: paperWidth });
        
        const pdfOpt = {
            margin: 0,
            html2canvas: { 
                scale: 4,  // Higher scale for better print quality
                useCORS: true, 
                backgroundColor: '#ffffff',
                logging: false,
                letterRendering: true,  // Better text rendering
                allowTaint: true
            },
            jsPDF: { 
                unit: 'mm', 
                format: [paperWidth, Math.max(contentHeightMM, 60)],
                compress: false  // No compression for better quality
            }
        };
        
        const pdfBlob = await html2pdf().from(contentElement).set(pdfOpt).outputPdf('blob');
        
        // Cleanup temp container
        document.body.removeChild(tempContainer);
        
        // Convert blob to base64
        const base64Data = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result.split(',')[1]);
            reader.readAsDataURL(pdfBlob);
        });
        
        await printPdf(printerName, base64Data, { width: paperWidth });
        console.log('✅ KOT print sent via QZ Tray');
        return true;
    } catch (error) {
        console.error('QZ Tray KOT print failed:', error);
        if (fallbackPrint) {
            fallbackPrint();
        }
        return false;
    }
};

export const qzTrayPdfPrintAPICall = async (printerName, pdfData, options = {}, fallbackPrint) => {
    store.dispatch(setBillLoading(true));
    try {
        const available = await isQzTrayAvailable();
        if (!available) {
            throw new Error('QZ Tray not connected');
        }
        
        // Convert blob to base64 if needed
        let base64Data = pdfData;
        if (pdfData instanceof Blob) {
            base64Data = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result.split(',')[1]);
                reader.readAsDataURL(pdfData);
            });
        }
        
        await printPdf(printerName, base64Data, options);
        store.dispatch(setBillLoading(false));
        store.dispatch(setSnackMsg("Print sent successfully"));
        store.dispatch(setSuccessSnack(true));
        return true;
    } catch (error) {
        console.error('QZ Tray PDF print failed:', error);
        store.dispatch(setSnackMsg("QZ Tray print failed, using fallback"));
        store.dispatch(setErrorSnack(true));
        store.dispatch(setBillLoading(false));
        if (fallbackPrint) {
            fallbackPrint();
        }
        return false;
    }
};

